import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';

class RequestRemovalModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'request-removal-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 50%;
          --modal-max-width: 50%;
          --modal-min-height: auto;
        }
      </style>
      <h3 slot="title">Request Removal</h3>
      <p>
        Submit a request to remove this device.
      </p>
      <bn-action
        .href="${this.href}"
        actionname="generate-removal-request"
        successtext="Removal Requested"
        errortext="An error occurred when trying to request removal."
        submittext="Request Removal"
        suppressheader
        @response="${this._onResponse}"
      ></bn-action>
    `;
  }

  _onResponse(e) {
    this.close();
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));
  }
}

window.customElements.define('request-removal-modal', RequestRemovalModal);
